import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { postApi } from '../ApiServices/api';
import { apiEndPoints } from '../ApiServices/config';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import throttle from 'lodash/throttle';

function PopUpNavigate() {
  const location = useLocation();
  const currentUrlPath = location.pathname;
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const timeoutIdRef = useRef(null);
  const dialogTimeout = 30 * 60 * 1000; // 30 minutes
  const consentTimeout = 2 * 60 * 1000; // 2 minutes
  const { logout } = useContext(UserContext);

  const handleLogout = async () => {
    localStorage.removeItem('devoteeData');
    localStorage.removeItem('token');
    logout();
    const terminal = localStorage.getItem('terminal');
    if (terminal) {
      const parsedTerminal = JSON.parse(terminal);
      if (parsedTerminal?.id) {
        const response = await postApi(apiEndPoints.updatePosLoggedinStatus, {
          id: parsedTerminal.id,
          status: false
        });
        if (response.status === 200) {
          localStorage.removeItem('terminal');
        }
      }
    }
    window.location.href = currentUrlPath;
  };

  const resetTimeout = useCallback(() => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    timeoutIdRef.current = setTimeout(() => {
      const newId = setTimeout(async () => {
        await handleLogout();
      }, consentTimeout);
      confirmAlert({
        title: 'Logout!',
        message: 'Are you sure you want to logout?',
        buttons: [
          {
            label: 'Yes',
            onClick: async () => {
              await handleLogout();
              clearTimeout(newId);
            }
          },
          {
            label: 'No',
            onClick: () => {
              resetTimeout();
              clearTimeout(newId);
            }
          }
        ]
      });
    }, dialogTimeout);
  }, [token, dialogTimeout, consentTimeout]);

  useEffect(() => {
    if (token) {
      resetTimeout();

      const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];
      const throttledReset = throttle(resetTimeout, 1000);

      events.forEach((event) => window.addEventListener(event, throttledReset));

      return () => {
        if (timeoutIdRef.current) {
          clearTimeout(timeoutIdRef.current);
        }
        events.forEach((event) => window.removeEventListener(event, throttledReset));
        throttledReset.cancel();
      };
    }
  }, [token, resetTimeout]);

  return null;
}

export default PopUpNavigate;
